import { authRoles } from './auth/authRoles'
import { FaWeight,FaTrash } from 'react-icons/fa'

let urlElements = window.location.href.split('/')

let prodUrl = 'https://'+urlElements[2];

export const navigations = [
    {
        name: 'Παρακολούθηση - Μηνιαία',
        path: '/citymonthstats',
        icon: 'calendar_month',
        auth: authRoles.sa
    },
    {
        name: 'Παρακολούθηση - Ετήσια',
        path: '/cityyearstats',
        icon: 'date_range'
        ,
        auth: authRoles.sa
    },
    // {
    //     name: 'TEST',
    //     path: '/biowaste',
    //     icon: 'dashboard',
    //     auth: authRoles.sa
    // },
    // {
    //     name: 'DATA',
    //     path: '/table',
    //     icon: 'dashboard',
    // },
    // {
    //     name: 'autocomplete',
    //     path: '/autocomplete',
    //     icon: 'dashboard',
    // },
    // {
        
    //     iconText: 'FP',
    //     type: 'label',
    // },
    {
        name: 'Εισαγωγή δεδομένων',
        icon: 'add_circle',
        auth: authRoles.sa,
        
        children: [
            {
                name: 'καταχωρηση βιοαποβλητων'.toUpperCase(),
                iconText: 'SI',
                // icon: 'data',
                path: '/waste_add',
                auth: authRoles.sa
                //auth: authRoles.sa,
            },
            {
                name: 'Κατηγοριες βιοαποβλητων'.toUpperCase(),
                iconText: 'SI',
                path: '/waste_type_add',
                auth: authRoles.sa
            },
            {
                name: 'Οχηματα'.toUpperCase(),
                iconText: 'SI',
                path: '/vehicle_add',
                auth: authRoles.sa
            },
            {
                name: 'Οδηγοι'.toUpperCase(),
                iconText: 'SI',
                path: '/driver_add',
                auth: authRoles.sa
            },
            {
                name: 'ΠΛΗΡΩΜΑ',
                iconText: 'SI',
                path: '/assistant_add',
                auth: authRoles.sa
            },
            {
                name: 'Περιοχες εξυπηρετησης'.toUpperCase(),
                iconText: 'SI',
                path: '/area_add',
                auth: authRoles.sa
            },
            {
                name: 'Δικτυο Καφε Καδου'.toUpperCase(),
                iconText: 'SI',
                path: '/servicearea_add',
                auth: authRoles.sa
            },
            {
                name: 'Στοιχεια Δημου'.toUpperCase(),
                iconText: 'SI',
                path: '/municipality_add',
                auth: authRoles.sa
            },
            // {
            //     name: 'Sign up',
            //     iconText: 'SU',
            //     path: '/session/signup',
            // },
            // {
            //     name: 'Forgot Password',
            //     iconText: 'FP',
            //     path: '/session/forgot-password',
            // },
            // {
            //     name: 'Error',
            //     iconText: '404',
            //     path: '/session/404',
            // },
        ],
    },


    {
        name: 'Προβολή βάσης δεδομένων',
        icon: 'listall',
        auth: authRoles.sa,
        
        children: [
            {
                name: 'βιοαποβλητα'.toUpperCase(),
                iconText: 'SI',
                // icon: 'data',
                path: '/waste_list',
                auth: authRoles.sa
                //auth: authRoles.sa,
            },
            {
                name: 'Κατηγοριες βιοαποβλητων'.toUpperCase(),
                iconText: 'SI',
                path: '/waste_type_list',
                auth: authRoles.sa
            },
            {
                name: 'Οχηματα'.toUpperCase(),
                iconText: 'SI',
                path: '/vehicle_list',
                auth: authRoles.sa
            },
            {
                name: 'Οδηγοι'.toUpperCase(),
                iconText: 'SI',
                path: '/driver_list',
                auth: authRoles.sa
            },
            {
                name: 'ΠΛΗΡΩΜΑ',
                iconText: 'SI',
                path: '/assistant_list',
                auth: authRoles.sa
            },
            {
                name: 'Περιοχες εξυπηρετησης'.toUpperCase(),
                iconText: 'SI',
                path: '/area_list',
                auth: authRoles.sa
            },
            {
                name: 'Δικτυο Καφε Καδου'.toUpperCase(),
                iconText: 'SI',
                path: '/servicearea_list',
                auth: authRoles.sa
            },
            {
                name: 'Στοιχεια Δημου'.toUpperCase(),
                iconText: 'SI',
                path: '/municipality_list',
                auth: authRoles.sa
            },
            // {
            //     name: 'Sign up',
            //     iconText: 'SU',
            //     path: '/session/signup',
            // },
            // {
            //     name: 'Forgot Password',
            //     iconText: 'FP',
            //     path: '/session/forgot-password',
            // },
            // {
            //     name: 'Error',
            //     iconText: '404',
            //     path: '/session/404',
            // },
        ],
    },
    // {
    //     name: 'ΣΥΝΟΛΑ ΔΗΜΟΥ - ΕΤΗΣΙΩΣ',
    //     path: '/m',
    //     icon: 'dashboard',
    // },
    // {
    //     name: 'ΠΕΡΙΟΧΕΣ ΔΗΜΟΥ',
    //     path: '/m',
    //     icon: 'dashboard',
    // },
    // {
    //     label: 'Pages',
    //     type: 'label',
    // },
    // {
    //     name: 'Session/Auth',
    //     icon: 'security',
    //     children: [
    //         {
    //             name: 'Sign in',
    //             iconText: 'SI',
    //             path: '/session/signin',
    //         },
    //         {
    //             name: 'Sign up',
    //             iconText: 'SU',
    //             path: '/session/signup',
    //         },
    //         {
    //             name: 'Forgot Password',
    //             iconText: 'FP',
    //             path: '/session/forgot-password',
    //         },
    //         {
    //             name: 'Error',
    //             iconText: '404',
    //             path: '/session/404',
    //         },
    //     ],
    // },

    
    {
        label: process.env.REACT_APP_VER,
        type: 'label',
        
        
        
    },



    // {
    //     label: 'Components',
    //     type: 'label',
    // },
    // {
    //     name: 'Components',
    //     icon: 'favorite',
    //     badge: { value: '30+', color: 'secondary' },
    //     children: [
    //         {
    //             name: 'Auto Complete',
    //             path: '/material/autocomplete',
    //             iconText: 'A',
    //             auth: authRoles.sa
    //         },
    //         {
    //             name: 'Buttons',
    //             path: '/material/buttons',
    //             iconText: 'B',
    //         },
    //         {
    //             name: 'Checkbox',
    //             path: '/material/checkbox',
    //             iconText: 'C',
    //         },
    //         {
    //             name: 'Dialog',
    //             path: '/material/dialog',
    //             iconText: 'D',
    //         },
    //         {
    //             name: 'Drag and Drop',
    //             iconText: 'D',
    //             path: '/others/drag-and-drop',
    //         },
    //         {
    //             name: 'Expansion Panel',
    //             path: '/material/expansion-panel',
    //             iconText: 'E',
    //         },
    //         {
    //             name: 'Form',
    //             path: '/material/form',
    //             iconText: 'F',
    //         },
    //         {
    //             name: 'Icons',
    //             path: '/material/icons',
    //             iconText: 'I',
    //         },
    //         {
    //             name: 'Menu',
    //             path: '/material/menu',
    //             iconText: 'M',
    //         },
    //         {
    //             name: 'Progress',
    //             path: '/material/progress',
    //             iconText: 'P',
    //         },
    //         {
    //             name: 'Radio',
    //             path: '/material/radio',
    //             iconText: 'R',
    //         },
    //         {
    //             name: 'Switch',
    //             path: '/material/switch',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Slider',
    //             path: '/material/slider',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Snackbar',
    //             path: '/material/snackbar',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Table',
    //             path: '/material/table',
    //             iconText: 'T',
    //         },
    //     ],
    // },
    // {
    //     name: 'Utilities',
    //     icon: 'format_list_bulleted',
    //     children: [
    //         {
    //             name: 'Color',
    //             path: '/utilities/color',
    //             iconText: 'C',
    //             auth: authRoles.sa,
    //         },
    //         {
    //             name: 'Spacing',
    //             path: '/utilities/spacing',
    //             iconText: 'S',
    //             auth: authRoles.sa,
    //         },
    //         {
    //             name: 'Typography',
    //             path: '/utilities/typography',
    //             iconText: 'T',
    //         },
    //         {
    //             name: 'Display',
    //             path: '/utilities/display',
    //             iconText: 'D',
    //         },
    //         {
    //             name: 'Position',
    //             path: '/utilities/position',
    //             iconText: 'P',
    //         },
    //         {
    //             name: 'Shadow',
    //             path: '/utilities/shadow',
    //             iconText: 'S',
    //         },
    //     ],
    // },
    // {
    //     name: 'Charts',
    //     icon: 'trending_up',
    //     children: [
    //         {
    //             name: 'Echarts',
    //             path: '/charts/echarts',
    //             iconText: 'E',
    //         }
    //     ],
    // },
    // {
    //     name: 'Documentation',
    //     icon: 'launch',
    //     type: 'extLink',
    //     path: 'http://demos.ui-lib.com/matx-react-doc/',
    // },
]
